var exports = {
  "MJ": "FormControl__bSu9We",
  "az": "Box__PiY6W7",
  "f0": "RepositoryPicker__gpalOl",
  "wy": "Box_1__uzkbnK",
  "EY": "Text__E6jwuG",
  "pv": "Box_2__6Hb3VY",
};

module.exports = exports;
